import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Snackbar, SnackbarContent, colors } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutlined';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import clsx from 'clsx'
import { useSelector, useDispatch, } from 'react-redux'
import { hideSnackbar, } from 'actions'

const useStyles = makeStyles(theme => ({
  success: {
    backgroundColor: colors.green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: colors.amber[700],
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: theme.spacing(2)
  }
}))

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
}


const SnackbarInfos = props => {
  const classes = useStyles()
  const userInterface = useSelector(state => state.interface);
  const dispatch = useDispatch();

  const Icon = variantIcon[userInterface.snackbar.variant]

  const closeSnackbar = () => {
    dispatch(hideSnackbar())
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      autoHideDuration={6000}
      onClose={closeSnackbar}
      open={userInterface.snackbar.isOpen}
    >
      <SnackbarContent
        className={clsx(classes[userInterface.snackbar.variant])}
        // variant={userInterface.snackbar.variant}
        message={
          <span className={classes.message}>
            <Icon className={classes.icon} />
            {userInterface.snackbar.message}
          </span>
        }
        variant="h6"
      />
    </Snackbar>
  );
};

export default SnackbarInfos;
